import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { paginationI, paginationInitialState } from 'app/core/interfaces/layout';

@Component({
  selector: 'page-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() public pagination: any = paginationInitialState; 
  @Output() callback: EventEmitter<any> = new EventEmitter();

  constructor(private cdRef:ChangeDetectorRef) { }

  ngOnInit() {

  }

  ngAfterViewChecked() {
    this.pagination.pages =  Math.ceil(this.pagination.total / this.pagination.limit);
    this.cdRef.detectChanges();
  }

  public get hideLoadMore()  {
    return !(this.pagination.page >= this.pagination.pages);
  }

  public get hideLoadLess()  {
    return !(this.pagination.page <= 1);
  }

  public get hidePagination() {
    return !(this.pagination.total <= this.pagination.limit);
  }

  loadMore() {
    this.pagination.page++;
    this.callback.emit(this.pagination);
  }
  
  loadLess() {
    this.pagination.page--;
    this.callback.emit(this.pagination);
  }

}
